import React from 'react';
import { Advertorial } from './pages/Advertorial';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '4567598480149930';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <>
      <Advertorial data-id="element-0" data-mp="3k89qfoo0ilfs" />
      <noscript data-id="element-1" data-mp="3k8t8r6hkrbuc">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3k78ezj333wxj" />
      </noscript>
    </>;
}